import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private snackBar: MatSnackBar) { }

  open(
    message: string,
    action: string,
    duration: number = 3000,
    horizontalPosition: "start" | "center" | "end" = "center",
    verticalPosition: "top" | "bottom" = "top",
    config?: MatSnackBarConfig
  ): MatSnackBarRef<any> { // Ensure this method returns MatSnackBarRef
    const snackBarConfig: MatSnackBarConfig = {
      duration: 7000,
      horizontalPosition: horizontalPosition,
      verticalPosition: verticalPosition,
      ...config // Merge with additional config if provided
    };

    // Open the snackbar and return the MatSnackBarRef
    return this.snackBar.open(message, action, snackBarConfig);
  }
}
